import { render, staticRenderFns } from "./RecordingForms.vue?vue&type=template&id=358c1784&"
import script from "./RecordingForms.vue?vue&type=script&lang=js&"
export * from "./RecordingForms.vue?vue&type=script&lang=js&"
import style0 from "./RecordingForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports